import { FacilityGroupCreatedEvent } from '@rematter/frontend-lib-api-client/grpc/core/v1/facilityGroup_events_pb';
import { Col, FieldDisplay, IDField } from '@rematter/ui-web';

type FacilityGroupCreatedDetailProps = {
  event: FacilityGroupCreatedEvent;
};

export const FacilityGroupCreatedDetail = ({
  event,
}: FacilityGroupCreatedDetailProps) => {
  const facilityGroup = event.facilityGroup;

  if (!facilityGroup) {
    return (
      <Col className="@FacilityGroupCreatedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  return (
    <Col className="@FacilityGroupCreatedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          Facility Group Details
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={facilityGroup.id?.value} />
          <FieldDisplay label="Name" value={facilityGroup.name} />
        </div>
      </Col>
    </Col>
  );
};
